// =============================================================================
//  pageHtmlAccess.js — Permission d'affichage du bouton « </> Edit HTML Code »
//
//  Miroir CLIENT de elakay_services/pageBuilderHtmlAccess.js (backend) --
//  utilisé UNIQUEMENT pour décider d'afficher/masquer le bouton. Le backend
//  reste la seule autorité réelle : chaque endpoint HTML re-vérifie tout
//  (rôle, default/owner, mot de passe) indépendamment de ce que React affiche.
//
//  Règle (même ordre que côté serveur) :
//    1. FAMILY                → toujours autorisé (default pages ET pages
//                                créées par Family).
//    2. DEFAULT PAGE          → refusé pour tout le monde d'autre
//                                (authorType "admin").
//    3. OWNER de la page      → autorisé.
//    4. sinon                 → refusé.
//
//  Une page qui n'a jamais été sauvegardée (pas de _id) n'a pas encore
//  d'endpoint HTML à appeler -- toujours refusé jusqu'à la première sauvegarde.
// =============================================================================

import { Family } from "../Rolle";

export function canEditPageHtml({ savedPage, currentUserId, userEmail } = {}) {
  if (!savedPage?._id) return false;
  if (Family(userEmail)) return true;
  if (savedPage.authorType === "admin") return false;
  return Boolean(currentUserId && savedPage.owner && String(savedPage.owner) === String(currentUserId));
}
